import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { ApiService } from "@services/api.service";
import { SessionService } from "@services/session.service";
import { environment } from "@env/environment";

interface VerificarSesionResponse {
    activa: boolean;
    msg?: string;
}

@Injectable({ providedIn: "root" })
export class VerificarSesionService {
    constructor(
        private apiService: ApiService,
        private sessionService: SessionService
    ) {}

    verificarSesion(): Observable<boolean> {
        const url = `${environment.backendUrl}/${environment.verificarSesion}`;
        const idSesion = this.sessionService.getSesionActual()?.id_sesion ?? "";

        return this.apiService
            .privatePostObservable<VerificarSesionResponse>(url, { idSesion })
            .pipe(map((response) => !!response?.activa));
    }
}
